import { makeAutoObservable } from 'mobx';

class PowerOfGodsStore {
  spinId = null;

  newHash = null;

  winAmount = null;

  partCashoutWinAmount = null;

  cashoutWinAmount = null;

  isBetsClosed = false;

  isDoSpinStart = false;

  winOdd = null;

  possibleActions = [];

  quickBets = [];

  isCashoutInProgress = false;

  isAllowCashOut = false;

  isAllowBet = false;

  isAllowPartCashOut = false;

  oddsInfo = {};

  line1AutoCashOut = null;

  line2AutoCashOut = null;

  cashOutOdd = 0;

  isWinPopupVisible = false;

  initialStateReady = false;

  initialStateSymbol = null;

  initialRingStates = null;

  initialBonusInfo = null;

  isBettingPartEnabled = true;

  isStoreLoaded = false;

  constructor() {
    makeAutoObservable(this);
    // reaction(
    //   () => gameController?.store,
    //   (value) => {
    //     if (value) {
    //     }
    //   }
    // );
  }

  setIsStoreLoaded(v) {
    this.isStoreLoaded = v;
  }

  setIsWinPopUpVisible(v) {
    this.isWinPopupVisible = v;
  }

  showWinPopup() {
    this.setIsWinPopUpVisible(true);
  }

  setCashoutInProgress(value) {
    this.isCashoutInProgress = value;
  }

  hideWinPopup() {
    this.setIsWinPopUpVisible(false);
    this.setCashoutInProgress(false);
  }

  setLine1AutoCashOut(odd) {
    this.line1AutoCashOut = odd;
  }

  setLine2AutoCashOut(odd) {
    this.line2AutoCashOut = odd;
  }

  setInitialStateReady(ready) {
    this.initialStateReady = ready;
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
  }

  setIsAllowPartCashPut(isAllow) {
    this.isAllowPartCashOut = isAllow;
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  setIsAllowCashOut(isAllow) {
    this.isAllowCashOut = isAllow;
  }

  setPartCashoutWinAmount(value) {
    this.partCashoutWinAmount = value;
  }

  setCashoutWinAmount(bool) {
    this.cashoutWinAmount = bool;
  }

  setIsAllowBet(isAllow) {
    this.isAllowBet = isAllow;
  }

  setOddsInfo(nameOfRing, odds) {
    this.oddsInfo[nameOfRing] = odds;
  }

  setInitialStateSymbol(symbol) {
    this.initialStateSymbol = symbol;
  }

  setInitialRingStates(states) {
    this.initialRingStates = states;
  }

  setInitialBonusInfo(info) {
    this.initialBonusInfo = info;
  }

  setQuickBets(quickBets) {
    this.quickBets = quickBets;
  }

  handleToInitStore() {
    this.winAmount = null;
    this.winOdd = null;
    this.possibleActions = [];
  }

  handleReset() {}
}

export const powerOfGodsStore = new PowerOfGodsStore();
